export const iconFontAwesomeDevicesHardwareTabletButton = (
	<i className="fa-solid fa-tablet-button"></i>
);
